import '@/metrics';
import '@/components/age_verification';
import '@/components/button';
import '@/components/form_handler';
import '@/components/horizontal_scroller';
import '@/components/recommended_title';
import '@/components/searchbox';
import '@/components/searchbox_new';
import '@/components/video_item';
import '@/components/video_list';
import '@/components/video_info';
import '@/components/image_list';
import '@/stores/app';
import '@/stores/layout_switcher';

import { getNotificationStore } from '@/stores/notification';
import { getDeviceStore } from '@/stores/device';
import { getModalHandlerStore } from '@/stores/modal_handler';
import { getScrollLockStore } from '@/stores/scroll_lock';
import { getModalStore } from '@/stores/modal';

getNotificationStore();
getDeviceStore();
const scrollLockStore = getScrollLockStore();
getModalHandlerStore(scrollLockStore);
getModalStore(scrollLockStore);
